import { enums } from 'console-kit';

const pwdStrengthText = {
  X1:       'Too Weak',
  X2:       'Weak',
  X3:       'Fair',
  X4:       'Good',
  X5:       'Strong',
  TOOSHORT: 'Too short',
  TOOLONG:  'Too long',
};

const loginTypes = {
  TYPE_FORM:    'form',
  TYPE_FORM2FA: 'form2fa',

  CESSSO_TYPE:          'cessso',
  CESSSO_INVITED_TYPE:  'cessso_invited',
  CESSSO_REDIRECT_TYPE: 'cessso_redirect', // hard redirect after at least one successful Zeta Login ID logging in
  INTSSO_TYPE:          'intsso', //currently not used
  SAML_TYPE:            'saml', //currently not used

  NONE: '',
};

const pwdStrengthRanks = {
  X0: {
    rank:  0,
    color: enums.colors.ERROR,
  },
  X1: {
    rank:  20,
    color: enums.colors.WARNING,
  },
  X2: {
    rank:  40,
    color: enums.colors.SUPER,
  },
  X3: {
    rank:  60,
    color: enums.colors.SUPER,
  },
  X4: {
    rank:  80,
    color: enums.colors.ACTION,
  },
  X5: {
    rank:  100,
    color: enums.colors.ACTION,
  },
};

const pwdStrengthLimits = {
  MIN_LENGTH:         12,
  SUPPORT_MIN_LENGTH: 12, //support or staff members need longer passwords to add that little extra for security
  MAX_LENGTH:         64,
};

export default {
  pwdStrengthRanks,
  pwdStrengthText,
  pwdStrengthLimits,
  loginTypes,
};
